import React from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import Spinner from "./Spinner";

const SearchField = React.forwardRef(({
  placeholder = "Search",
  value = "",
  onChange,
  iconPosition,
  className = "",
  icon = "pi pi-search",
  handleIconClick = () => { },
  handleClearClick = () => { },
  handleKeyDown = () => { },
  loading = false,
  type = "text",
  name,
}, ref) => {
  const { i18n, t } = useTranslation();
  const inputProps = {
    placeholder: t(placeholder),
    onKeyDown: (e) => {
      if (loading) return;
      if (e.key === "Enter") {
        e.preventDefault();
        handleKeyDown(e);
      }
    },
    onChange,
    pt: {
      root: { className: "!p-0 border-0 w-full h-full !bg-transparent" },
      icon: { className: "cursor-pointer" },
    },
    name,
    ref
  };

  if (value) {
    inputProps.value = value;
  } else {
    inputProps.value = "";
  }

  return (
    <div className={`h-full w-full ${className}`}>
      <IconField
        disabled={loading}
        type={type}
        iconPosition={
          iconPosition ? iconPosition : i18n.language == "ar" ? "left" : "right"
        }
        pt={{ root: { className: "input-field !p-0 !px-2 cursor-pointer" } }}
      >
        {!loading ? (
          value ? (
            <InputIcon
              onClick={handleClearClick}
              className={"pi pi-times"}
            ></InputIcon>
          ) : (
            <InputIcon onClick={handleIconClick} className={icon}></InputIcon>
          )
        ) : (
          <InputIcon
            className={
              iconPosition == "left"
                ? "pi pi-spin pi-spinner"
                : "pi pi-spin pi-spinner"
            }
          ></InputIcon>
        )}
        <InputText {...inputProps} />
      </IconField>
    </div>
  );
});

export default SearchField;
